import { useT } from "@/lib/i18n";

const MAILBOXES = ["contact", "licensing", "artists", "press"];

// hidden: true = temporarily not rendered (accounts not yet posting); URLs kept for re-enabling later.
const SOCIALS = [
  { name: "YouTube", url: "https://www.youtube.com/@IstanbulFrequency" },
  {
    name: "Instagram",
    url: "https://www.instagram.com/istanbulfrequency/",
    hidden: true,
  },
  {
    name: "TikTok",
    url: "https://www.tiktok.com/@istanbulfrequency",
    hidden: true,
  },
  { name: "X", url: "https://x.com/IstanbulFreq", hidden: true },
  {
    name: "Facebook",
    url: "https://www.facebook.com/people/Istanbul-Frequency/61593203174593/",
    hidden: true,
  },
];

export const Footer = () => {
  const t = useT();

  return (
    <footer data-testid="footer" className="border-t border-if-line">
      <div className="mx-auto max-w-7xl px-6 py-16 md:px-12 xl:px-24">
        <div className="flex flex-col gap-12 md:flex-row md:items-start md:justify-between">
          <div>
            <p className="font-sans text-[11px] font-medium uppercase tracking-[0.35em] text-if-text">
              {t.brand.name}
            </p>
            <p className="mt-3 font-sans text-[10px] uppercase tracking-[0.35em] text-if-gold">
              {t.brand.tagline}
            </p>
          </div>
          <div>
            <p className="mb-4 font-sans text-[10px] uppercase tracking-[0.25em] text-if-dim/70">
              {t.footer.emailsTitle}
            </p>
            <ul data-testid="footer-emails" className="space-y-2">
              {MAILBOXES.map((m) => (
                <li
                  key={m}
                  className="font-sans text-xs text-if-dim"
                  data-testid={`footer-email-${m}`}
                >
                  {m}@istanbulfrequency.com
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="mb-4 font-sans text-[10px] uppercase tracking-[0.25em] text-if-dim/70">
              {t.footer.followTitle}
            </p>
            <ul data-testid="footer-socials" className="space-y-2">
              {SOCIALS.filter((s) => !s.hidden).map((s) => (
                <li key={s.name}>
                  <a
                    href={s.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Istanbul Frequency on ${s.name}`}
                    data-testid={`footer-social-${s.name.toLowerCase()}`}
                    className="font-sans text-xs text-if-dim transition-colors duration-300 hover:text-if-gold"
                  >
                    {s.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="mt-16 flex flex-col gap-3 border-t border-if-line pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-[11px] font-light text-if-dim">{t.footer.rights}</p>
          <p className="font-sans text-[10px] uppercase tracking-[0.3em] text-if-dim/70">
            {t.footer.location}
          </p>
        </div>
      </div>
    </footer>
  );
};
